export default "__VITE_ASSET__DGaRswHp__"